module.exports = __webpack_public_path__ + "img/banner1.65bb6084.png";